import React from 'react';
interface OverlineProps {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
  className?: string;
}
export function Overline({
  children,
  tone = 'dark',
  className = ''
}: OverlineProps) {
  return <p className={`text-[11px] font-medium uppercase tracking-overline ${tone === 'light' ? 'text-champagne' : 'text-walnut'} ${className}`} data-id="element-303" data-mp="23zhm6ioonhfd">
      {children}
    </p>;
}